import React from "react";
import UniversalSidebar from "./UniversalSidebar";
import Navbar from "../Navbar";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
import { MobileMenuWrapper } from "../mobile/MobileMenuWrapper";

type AppLayoutProps = {
  children: React.ReactNode;
};

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  
  // Painéis usam UniversalSidebar, EXCETO o painel do jogador que tem sua própria sidebar
  const isAdmin = pathname.startsWith('/painel-admin');
  const isMentor = pathname.startsWith('/painel-mentor');
  const isPlayer = pathname.startsWith('/painel-jogador');
  const isPanel = isAdmin || isMentor || isPlayer;
  
  // Páginas que não devem mostrar navbar (como login, callback, etc.)
  const noNavbarPages = ['/login', '/cadastro', '/recuperar-senha', '/auth/callback'];
  const shouldShowNavbar = !isPanel && !noNavbarPages.some(page => pathname.startsWith(page));
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar para páginas públicas */}
      {shouldShowNavbar && <Navbar />}
      
      {/* Sidebar para painéis - EXCETO painel do jogador */}
      {(isAdmin || isMentor) && <UniversalSidebar />}
      
      <main className={`flex-1 ${
        (isAdmin || isMentor)
          ? 'transition-all duration-300 md:ml-16 lg:ml-64' 
          : isPlayer
            ? '' // Painel do jogador não precisa de margin-left pois tem seu próprio layout
            : shouldShowNavbar 
              ? 'pt-20 pb-12' // Espaço para a navbar fixa e espaçamento inferior
              : 'pb-12' // Espaçamento inferior para páginas sem navbar
      } ${isPanel ? 'pt-16 pb-20 md:pt-0 md:pb-0' : ''}`}>
        {children}
      </main>
      
      {/* Mobile menus for panels */}
      <MobileMenuWrapper />
      
      {/* Footer apenas para páginas públicas, não para painéis */}
      {!isPanel && <Footer />}
    </div>
  );
};

export default AppLayout;
